import { Badge, Box, useMediaQuery, useTheme } from "@mui/material";
import { useFetchGithub } from "features/metadesk/redux/fetchGithub";
import { useFetchEntityConfig } from "features/metadesk/redux/hooks";
import _ from "lodash";
import React, { useRef, useState } from "react";
import GithubIssue from "./GithubIssue";

import {
  StyledControlArea,
  StyledDrawer,
  StyledDrawerContainer,
  StyledTab,
  StyledTabPanel,
  StyledTabs,
} from "./TicketDrawer.styles";

import LinearIssue from "./LinearIssue";
import useGetPagePermission from "hooks/useGetPagePermission";
import JiraIssue from "./JiraIssue";
import { UserInfo } from "features/metadesk";

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

const TicketDrawer = ({
  entityName,
  selectedTicket,
  userCanEdit,
  userAddress,
}) => {
  const [value, setValue] = useState(0);

  const [open, setOpen] = useState(true);
  const { githubIssues } = useFetchGithub();
  const { entityConfig } = useFetchEntityConfig();
  const pagePermission = useGetPagePermission();
  const { readOnly } = pagePermission("tickets");
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down("md"));
  const tagTeam = _.map(selectedTicket?.tagTeam || [], "address");
  const [isLinearSelected, setIsLinearSelected] = useState(false);

  const handleToggle = () => {
    setOpen((prev) => !prev);
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleTabSelected = (tabElement) => {
    const elementType = tabElement.type;
    const src = tabElement?.props?.src;

    // special case for linear
    if (elementType === "img" && src?.includes("linear")) {
      setIsLinearSelected(true);
    } else {
      setIsLinearSelected(false);
    }
  };

  const renderArrow = () => {
    let arrow;
    if (open) {
      arrow = !mobile ? (
        <i className="meta-crm-icon-ic_arrowLineRight font-size-16" />
      ) : (
        <i className="meta-crm-icon-ic_arrowLineUp font-size-16" />
      );
    } else {
      arrow = !mobile ? (
        <i className="meta-crm-icon-ic_arrowLineLeft font-size-16" />
      ) : (
        <i className="meta-crm-icon-ic_arrowLineDown font-size-16" />
      );
    }
    return arrow;
  };

  const renderUserInfo = () => {
    const userId = _.get(selectedTicket, "user._id");
    if (!userId) return;
    return (
      <div
        style={{
          background: "#FAFAFD",
          padding: 0,
          width: "100%",
          overflowX: "hidden",
          height: "100%",
          position: "relative",
          overflowY: "scroll",
        }}
      >
        <UserInfo
          selectedUserIds={userId ? [userId] : ""}
          entityName={entityName}
          isTicketUserInfo={true}
        />
      </div>
    );
  };

  const renderGithubIssue = () => (
    <GithubIssue selectedTicket={selectedTicket} />
  );

  const renderLinearIssue = () => (
    <LinearIssue selectedTicket={selectedTicket} />
  );

  const renderJiraIssue = () => <JiraIssue selectedTicket={selectedTicket} />;

  const tabsLabel = [
    <i className="meta-crm-icon-ic_appUserProfile font-size-40" />,
    // <i className="meta-crm-icon-ic_search font-size-28" />,
    // <i className="meta-crm-icon-ic_appDid font-size-40" />,
  ];

  const tabsContent = [
    renderUserInfo(),
    // renderSearchAddressInfo(),
    // renderDIDInfo(),
  ];

  if (_.get(entityConfig, "serviceModule.github.connected")) {
    tabsLabel.push(
      <Badge
        color="secondary"
        badgeContent={
          <span style={{ marginTop: 2 }}>{githubIssues.length}</span>
        }
      >
        <i className="meta-crm-icon-ic_github font-size-20" />
      </Badge>
    );
    tabsContent.push(renderGithubIssue());
  }

  if (_.get(entityConfig, "serviceModule.linear.enabled")) {
    const readOnlyAssigned =
      readOnly && (selectedTicket.isAssigned || tagTeam.includes(userAddress));

    if (userCanEdit || readOnlyAssigned) {
      tabsLabel.push(
        <img
          src={
            isLinearSelected
              ? require(`assets/img/linear-icon.svg`).default
              : require(`assets/img/linear-icon-gray.svg`).default
          }
          style={{ height: 20, width: 20 }}
        />
      );
      tabsContent.push(renderLinearIssue());
    }
  }

  if (_.get(entityConfig, "serviceModule.jira.enabled")) {
    const readOnlyAssigned =
      readOnly && (selectedTicket.isAssigned || tagTeam.includes(userAddress));

    if (userCanEdit || readOnlyAssigned) {
      tabsLabel.push(<i className="meta-crm-icon-ic_jiraLogo font-size-20" />);
      tabsContent.push(renderJiraIssue());
    }
  }

  return (
    <StyledDrawer
      anchor={!mobile ? "right" : "top"}
      variant="permanent"
      open={open}
      ModalProps={{
        keepMounted: true,
      }}
    >
      <StyledControlArea onClick={handleToggle}>
        {renderArrow()}
      </StyledControlArea>
      <StyledDrawerContainer open={open}>
        <StyledTabs
          orientation={!mobile ? "vertical" : "horizontal"}
          value={value}
          onChange={handleChange}
          aria-label="Vertical tabs example"
          indicatorColor={"transparent"}
        >
          {userCanEdit &&
            tabsLabel.map((tab, index) => (
              <StyledTab
                onClick={() => handleTabSelected(tab)}
                label={tab}
                {...a11yProps(index)}
                key={index}
              />
            ))}
        </StyledTabs>

        {tabsContent.map((tabContent, index) => (
          <StyledTabPanel open={open} value={value} index={index} key={index}>
            {tabContent}
          </StyledTabPanel>
        ))}
      </StyledDrawerContainer>
    </StyledDrawer>
  );
};

export default TicketDrawer;
